import moment from 'moment';
import DatePicker from "vue2-datepicker";
import BenefitsService from "@/service/BenefitsService";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffBenefits } from "@/model/StaffBenefits";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employmentStaffBenefitsValidationObj from "./S070200-EmploymentStaffBenefitsValidation.js";
import Settings from '../../../constants/Settings.js';
var employmentStaffBenefitsObj = new employmentStaffBenefitsValidationObj();
export default {
  name: "staffBenefit",
  components: {
    DatePicker
  },
  props: [
    "staffModel", "isBenefitEditMode", "isBenefitViewMode"
  ],
  data: () => ({
    benefitLocalization: t,
    benefitDictEnum: dictEnum,
    staffBenefit: new StaffBenefits(),
    benefitList: [],
    tempBenefitModel: {
      PlanCode: ""
    },
    listKey: 1,
    IsLoaded: true,
    IsStaffBenefitTab: false,
    benefitObj: {
      selectAll: false
    },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    employmentStaffBenefitsObj.staffBenefitValidation();
  },
  methods: {
    async getAllBenefit() {
      var self = this;
      const obj = {
        staffGrade: this.staffModel.StaffEmployment.StaffGrade
      };
      const response = await BenefitsService.getAllBenefitByStaffGrade(obj);
      if (response.data.IsSuccess) {
        self.benefitList = response.data.Data;
        if (self.isBenefitViewMode && self.benefitList.length > 0 && self.staffModel.StaffBenefitList.length > 0) {
          self.staffModel.StaffBenefitList.forEach(element => {
            var benefitDetail = self.benefitList.find(
              (obj) => obj.PlanCode == element.PlanCode
            );
            element.BenefitDes = self.user.Lang == 'EN' ? benefitDetail.EDesc : benefitDetail.CDesc;
          });
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAddStaffBenefitButtonClick: function () {
      this.benefitObj.selectAll = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          var self = this;
          var tempCode = 1;
          var seq = 1;
          self.staffModel.StaffBenefitList.forEach(element => {
            if (element.DateEff != null && element.DateEff != "") {
              element.DateEff = moment(element.DateEff).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateExp != null && element.DateExp != "") {
              element.DateExp = moment(element.DateExp).format(Settings.DateTime.yyyymmdd);
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffBenefit = new StaffBenefits();
          staffBenefit.StaffID = self.staffModel.StaffID;
          staffBenefit.Seq = seq;
          staffBenefit.tempCode = tempCode;
          staffBenefit.IsEditMode = true;
          self.staffModel.StaffBenefitList.push(staffBenefit);
        }
      });
    },
    OnStaffBenefitDeleteClick: function (data) {
      var self = this;
      self.staffModel.StaffBenefitList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.staffModel.StaffBenefitList.splice(index, 1);
          return;
        }
      });
    },
    OnStaffBenefitSelection: function (item) {
      var self = this;
      if (self.isBenefitViewMode) {
        return;
      }
      if (item.IsEditMode) {
        return;
      }
      self.IsLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.staffModel.StaffBenefitList.forEach(element => {
            if (element.DateEff != null && element.DateEff != "") {
              element.DateEff = moment(element.DateEff).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateExp != null && element.DateExp != "") {
              element.DateExp = moment(element.DateExp).format(Settings.DateTime.yyyymmdd);
            }
            if (element.tempCode == item.tempCode) {
              self.IsLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsLoaded = true;
              element.IsEditMode = false;
            }
          });
          self.listKey += 1;
        }
        self.IsLoaded = true;
      });
    },
    OnBenefitBtnClick: function () {
      $("#benefitModel").modal("show");
    },
    OnBenefitSelect: function (model) {
      var self = this;
      self.tempBenefitModel = model;
    },
    OnBenefitModalSelectBtnClick: function () {
      var self = this;
      self.staffModel.StaffBenefitList.forEach(element => {
        if (element.IsEditMode) {
          element.BenefitDes = self.user.Lang == 'EN' ? self.tempBenefitModel.EDesc : self.tempBenefitModel.CDesc;
          element.PlanCode = self.tempBenefitModel.PlanCode;
        }
      });
      const field = this.$validator.fields.find("planCode");
      field.reset();
      this.$validator.errors.remove(field.name, field.scope);
      $("#benefitModel").modal("hide");
      self.tempItemModel = {};
    },
    selectAllBenefitRecord: function () {
      var self = this;
      var IsSelected = self.benefitObj.selectAll;
      self.staffModel.StaffBenefitList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeBenefitPopup: function () {
      var self = this;
      $('#deleteBenefitModel').modal('hide');
    },
    deleteMultipleBenefitPopup: function () {
      var arrayList = [];
      var self = this;
      self.staffModel.StaffBenefitList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteBenefitModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.benefitLocalization.t(self.benefitDictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleBenefit: function () {
      var self = this;
      var staffBenefitList = self.staffModel.StaffBenefitList.filter(
        obj => obj.isSelected !== true
      );
      self.staffModel.StaffBenefitList = staffBenefitList;
      self.benefitObj.selectAll = false;
      $('#deleteBenefitModel').modal('hide');
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmploymentStaffBenefit.js